// Explore and a format's Sonar, in the new interface (9 October 2026):
// `pages/epure/ESonar.vue`. The Sonar words the classic screen already had
// (`sonar.statut`, `sonar.mots`, `sonar.titre`, `sonar.relecture`…) are still
// read from `sonar`; only the mock-ups' texts and the audience picker live here.
export default {
  ariane: 'Breadcrumb',
  explorer: {
    sousTitre: 'An open question, put to the audiences you choose',
    vosEtudes: 'Your studies',
  },
  format: {
    titre: 'Sonar',
    sousTitre: 'A question about {titre}, put to its targets: what they choose, what they prefer, what they say about it',
    poseeA: 'Put to your targets, {cibles}',
    poseeAuPanel: 'Put to the format’s panel',
    changer: 'change',
    changerAria: 'Change the targets of {titre}',
    aucune: 'No question about {titre} yet.',
  },
  piste: {
    titre: 'Prepared answers: {titre}',
    aide: 'The panel will choose among these answers; untick the ones to drop. You still review the study before launching it.',
    oublier: 'Do not keep them',
    saison: 'What the panel will know about the season',
    saisonAide: 'Facts only, no ratings or opinions: the panel reads it before answering. Clear it so they know nothing.',
  },
  question: {
    libelle: 'Your question',
    exemples: 'For example:',
    publicRequis: 'Choose at least one audience to ask.',
  },
  heure: {
    libelle: 'Ask as of',
    maintenant: 'Now',
    revenir: 'Back to now',
    passee: 'The twins answer as of that moment.',
    avenir: 'The study will start at that time.',
    commeLe: 'As of {quand}',
    partira: 'It will start on {quand}.',
  },
  publics: {
    libelle: 'Who to ask',
    choisis: 'Chosen:',
    aucun: 'No audience chosen yet.',
    compte: '{n} of {max} at most',
    toutRetirer: 'Remove all',
    retirer: 'Remove {nom}',
    rechercher: 'Search',
    rechercherDans: 'Search: {famille}',
    aucunResultat: 'No audience matches.',
    maximum: '{max} audiences at most: remove one to choose another.',
    termine: 'Done',
    choisisDans: 'none chosen | {n} chosen | {n} chosen',
    chargement: 'Loading the audiences…',
    illisibles: 'The audiences could not be loaded.',
    fermes: 'Choosing audiences is not open to your account.',
    aucunOuvert: 'No audience you can ask is open to your account yet.',
    famille: {
      // The simulation's cities: their twins answer (4 November 2026).
      simulation: 'Cities',
      pays: 'Countries',
      chaine: 'Channels',
      plateforme: 'Platforms',
      jeunes: 'Young audiences',
      thematique: 'Verticals',
      // A country's electorate, for accounts with Polis (11 October 2026).
      politique: 'Politics',
      programme: 'Programme audiences',
      autres: 'Other audiences',
    },
  },
  statut: {
    rendu: 'Delivered',
  },
  vote: {
    questionPosee: 'The question put to the panel',
  },
  relecture: {
    auPlus: 'At most {nb} in the list: remove a few.',
  },
  fine: {
    affiner: 'Refine',
    replier: 'Collapse',
    toutLePanel: 'The whole panel',
    effacer: 'Clear all',
    retirer: 'Remove: {critere}',
    part: '{pct} of residents, about {personnes} people',
    partSeule: '{pct} of residents',
    tropPeu: 'Too few respondents in this filter to read it.',
    personne: 'Nobody matches this filter.',
    interrogerGroupe: 'Question this group',
    questionsSeul: {
      q1: 'What made you answer that?',
      q2: 'Tell me about one of your evenings: where are you, and what do you watch?',
      q3: 'What could change your mind?',
    },
    parlerAUn: 'Talk to one of them',
    ventiler: 'Break down by',
    age: 'Age',
    de: 'From',
    a: 'to',
    ans: 'years',
    ageDe: '{lo} to {hi} years old',
    ageDes: '{lo} and older',
    ageJusque: 'Up to {hi} years old',
    criteres: {
      sexe: 'Sex',
      statut: 'Activity',
      csp: 'Occupation',
      diplome: 'Education',
      logement: 'Housing',
      revenu: 'Net monthly income',
      transport: 'Gets around',
      nationalite: 'Nationality',
      quartier: 'District',
      vote: '2022 presidential, 1st round',
    },
    axes: {
      age: 'Age',
      sexe: 'Sex',
      statut: 'Activity',
      csp: 'Occupation',
      diplome: 'Education',
      logement: 'Housing',
      revenu: 'Income',
      quartier: 'District',
      vote: '2022 vote',
    },
    ages: { a8_14: '8-14', a15_24: '15-24', a25_34: '25-34', a35_49: '35-49', a50_64: '50-64', a65plus: '65 and older' },
    sexe: { f: 'Women', h: 'Men' },
    statut: { actif: 'Employed', chomeur: 'Unemployed', retraite: 'Retired', etudiant: 'Students', eleve: 'Pupils', inactif: 'Other inactive' },
    csp: { cadre: 'Managers and professionals', intermediaire: 'Intermediate occupations', employe: 'Clerical and service workers', ouvrier: 'Manual workers', artisan_commercant: 'Craftspeople, shopkeepers', agriculteur: 'Farmers' },
    diplome: { aucun: 'No diploma or lower secondary', cap: 'Vocational certificate', bac: 'High school diploma', bac3: '2 to 3 years of higher education', bac5: 'Master’s level and above' },
    logement: { proprietaire: 'Homeowners', prive: 'Private renters', hlm: 'Social housing renters', meuble: 'Furnished rentals', gratuit: 'Housed free of charge' },
    revenu: { sans: 'No income', rmoins1500: 'Under €1,500', r1500a2500: '€1,500 to €2,500', r2500a4000: '€2,500 to €4,000', rplus4000: '€4,000 and over' },
    transport: { transports: 'Public transport', voiture: 'By car', velo: 'By bike', marche: 'On foot', deux_roues: 'Two-wheeler', aucun: 'Does not commute' },
    nationalite: { francaise: 'French', etrangere: 'Foreign' },
    abstention: 'Abstention',
    qui: {
      f: 'Woman',
      h: 'Man',
      fille: 'Girl',
      garcon: 'Boy',
      ans: '{n}',
      statut: { f: { chomeur: 'unemployed', retraite: 'retired', etudiant: 'student', eleve: 'pupil', inactif: 'not working' }, h: { chomeur: 'unemployed', retraite: 'retired', etudiant: 'student', eleve: 'pupil', inactif: 'not working' } },
      csp: { f: { cadre: 'manager', intermediaire: 'intermediate occupation', employe: 'clerical worker', ouvrier: 'manual worker', artisan_commercant: 'craftsperson or shopkeeper', agriculteur: 'farmer' }, h: { cadre: 'manager', intermediaire: 'intermediate occupation', employe: 'clerical worker', ouvrier: 'manual worker', artisan_commercant: 'craftsperson or shopkeeper', agriculteur: 'farmer' } },
      unJumeau: 'One of them',
    },
  },
}
